export default __webpack_public_path__ + "static/media/MN.74ba2300.svg";